import { api } from "@/lib/lamka";

const needsUnlock = (e) => {
  const s = e?.response?.status;
  const d = String(e?.response?.data?.detail || "").toLowerCase();
  return (s === 401 || s === 403 || s === 423) && (d.includes("lock") || d.includes("admin") || d.includes("password"));
};

// Runs an admin call; if the main backend says admin mode is locked, asks for the admin password once and retries.
export const withAdminUnlock = async (fn, askPassword) => {
  try {
    return await fn();
  } catch (e) {
    if (!needsUnlock(e)) throw e;
    const password = await askPassword();
    if (!password) throw new Error("cancelled");
    await api.post("/admin/unlock", { password });
    return fn();
  }
};

export const adminDeleteListing = (id) => api.delete(`/admin/listings/${id}`);
export const updateListing = (id, body) => api.put(`/listings/${id}`, body).then((r) => r.data);
export const adminSetCategory = (id, category) => api.post(`/admin/listings/${id}/category`, { category });
